import { format } from 'date-fns';

import { ItemWithTimeStatus } from '../../../helpers';

interface getTabHeadersArgs {
  itemsByDay: [string, ItemWithTimeStatus[]][];
  dateLocale: Locale;
  showEmptyTabs?: boolean;
  dateFormat?: string;
}

export const getTabHeaders = ({
  itemsByDay,
  dateLocale,
  showEmptyTabs = true,
  dateFormat = 'LLLL dd',
}: getTabHeadersArgs) =>
  itemsByDay
    .map(([day, dayItems], index) => {
      const date = new Date(day);
      const dateIgnoringTimezone = new Date(
        date.valueOf() + date.getTimezoneOffset() * 60 * 1000,
      );
      return {
        day,
        index,
        empty: !dayItems.length,
        label: format(dateIgnoringTimezone, dateFormat, {
          locale: dateLocale,
        }),
        count: dayItems.length,
      };
    })
    .filter(header => showEmptyTabs || !header.empty);
